/**
 * @group DOM Attribute
 */
const name = 'list-reverse';

export {name as LIST_REVERSE};
